import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import resources from "./assets/i18n/index";
/*Customize language based on device locale*/
//import { Globalization } from '@ionic-native/globalization';
import { isPlatform, getPlatforms } from "@ionic/react";

// const getLocale = async () => {
//   let locale = {};
//   try {
//     let runTime = isPlatform('cordova') ? 'cordova' : isPlatform('capacitor') ? 'capacitor' : null;
//     if (['cordova', 'capacitor'].includes(runTime)) {// must have cordova or capacitor to use Globalization
//       let phoneType = isPlatform('ios') ? 'ios' : isPlatform('android') ? 'android' : null;
//       if (['ios', 'android'].includes(phoneType)) {
//         locale.phoneType = phoneType;
//         locale.locale = await Globalization.getLocaleName() || 'not found';
//         locale.lang = await Globalization.getPreferredLanguage() || 'not found';
//         locale.currency = await Globalization.getCurrencyPattern() || 'not found';
//         locale.datePattern = await Globalization.getDatePattern() || 'not found';
//       }
//     }
//     locale.runTime = 'not cordova, capacitor';
//     locale.lang = navigator.language || 'preferred language not found';
//   } catch (error) {
//     console.log('error');
//   } finally { console.log(locale) }

// }

let i18n_default_lang = "en";

// const getLocale = () => {
//     let defaultLang = navigator.language || "chn";
//     console.log("device preferred lang: " + defaultLang);
//     if (defaultLang == "en" || defaultLang.includes("en-")) {
//         i18n_default_lang = "en";
//     }
//     if (defaultLang == "zh" || defaultLang.includes("zh-")) {
//         i18n_default_lang = "chn";
//     }
// };
// getLocale();
console.log("i18n_default_lang:" + i18n_default_lang);

i18n.use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        lng: i18n_default_lang,

        //keySeparator: false, // we use keys in form messages.welcome

        interpolation: {
            escapeValue: false, // react already safes from xss
        },
    });

export default i18n;
